module.exports = __webpack_public_path__ + "static/media/WAVE_BANDIT2x.0bbc3900.png";